// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsDetailsOptionsStyles, MyListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsOptions";
import { ProductSelectorStyles } from "@pacific/Overrides/Components/ProductSelector";
import { color } from "@pacific/XDL/Utilities";
import { css } from "styled-components";

export interface XngMyListsDetailsOptionsStyles extends MyListsDetailsOptionsStyles {
    productSelectorStyles?: ProductSelectorStyles;
}

myListsDetailsOptionsStyles.rightColumnWrapper = {
    ...myListsDetailsOptionsStyles.rightColumnWrapper,
    css: css`
        display: flex;
        width: 40px;
        justify-content: center;
    `,
};

myListsDetailsOptionsStyles.container = {
    ...myListsDetailsOptionsStyles.container,
    css: css`
        margin-top: 28px;
    `,
};

myListsDetailsOptionsStyles.addItemsGridContainer = {
    ...myListsDetailsOptionsStyles.addItemsGridContainer,
    css: css`
        margin-top: 28px;
    `,
};

(myListsDetailsOptionsStyles as XngMyListsDetailsOptionsStyles).productSelectorStyles = {
    ...myListsDetailsOptionsStyles.productSelectorStyles,
    clearIcon: {
        css: css`
            position: absolute;
            right: 32px;
            top: 11px;
            cursor: pointer;
        `,
    },
    productQuantityOrderedStyles: {
        actionsStyles: {
            wrapper: {
                css: css`
                    height: 36px;
                `
            },
            actionClickable: {
                css: css`
                    height: 36px;
                `,
            },
            quantityOrderedTextField: {
                cssOverrides: {
                    inputSelect: css`
                        height: 36px;
                    `,
                },
            },
        },
    },
    buttonGridItem: { width: [12, 12, 2, 2, 2] },
    selectButton: {
        css: css`
            && {
                margin-top: 0;
            }
        `,
    },
};

myListsDetailsOptionsStyles.uploadItemsGridItem = {
    ...myListsDetailsOptionsStyles.uploadItemsGridItem,
    css: css`
        align-items: flex-start;
    `,
};

myListsDetailsOptionsStyles.uploadItemsLink = {
    ...myListsDetailsOptionsStyles.uploadItemsLink,
    css: css`
        margin: 5px 0 0;
    `,
};

myListsDetailsOptionsStyles.sortByOverflowMenu = {
    ...myListsDetailsOptionsStyles.sortByOverflowMenu,
    cssOverrides: {
        wrapper: css`
            margin-top: 25px;
        `,
    },
};

myListsDetailsOptionsStyles.closeAddItemsToList = {
    ...myListsDetailsOptionsStyles.closeAddItemsToList,
    css: css`
        margin: 8px;
        margin-top: 32px;
        cursor: pointer;
        align-items: flex-start;
    `,
};

myListsDetailsOptionsStyles.selectAll = {
    css: css`
        cursor: pointer;
        &[disabled] {
            cursor: not-allowed;
        }
    `,
};

myListsDetailsOptionsStyles.editSortOrder = {
    css: css`
        cursor: pointer;
        margin-left: 30px;
        &[disabled] {
            cursor: not-allowed;
        }
    `,
};

myListsDetailsOptionsStyles.selectedSortByClickable = {
    css: css`
        &:disabled {
            color: ${color("primary.main", 0.33)};
        }
    `,
};

